import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbDialogService } from '@nebular/theme';
import { Subscription } from 'rxjs';
import {
  UiAccountsControllerService,
  UiSettingsControllerService,
  UiStackControllerService,
} from 'src/app/cc-api/services';
import { CacheDataService } from 'src/app/services/cache-data.service';
import { ContextUpdatesService } from 'src/app/services/context-updates.service';
import { triggerAnalyticsEvent } from 'src/app/utils/analytics/trigger-analytics';
import { FeatureFlagsService } from 'src/app/services/feature-flags.service';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.scss'],
})
export class OnboardingComponent implements OnInit, OnDestroy {
  @ViewChild('onboardingStepper') onboardingStepper: TemplateRef<any>;
  @ViewChild('inviteUserTemplateRef') inviteUserTemplateRef: TemplateRef<any>;

  contextUpdates$: Subscription;
  vcsAccounts = [];
  errorCreatingStarterProject: string;
  disableStep2: boolean = true;
  gitProviders = ['GITHUB', 'GITLAB', 'BITBUCKET'];
  selectedGitProvider: string;
  creatingProject: boolean = true;
  routeParamSubscriber: Subscription;

  constructor(
    private dialogService: NbDialogService,
    private uiStackControllerService: UiStackControllerService,
    private router: Router,
    private contextUpdatesService: ContextUpdatesService,
    private accountControllerService: UiAccountsControllerService,
    private cacheDataService: CacheDataService,
    private uiSettingsControllerService: UiSettingsControllerService,
    private activatedRoute: ActivatedRoute,
    private featureFlagService: FeatureFlagsService,
  ) {}

  async ngOnInit() {
    if (this.featureFlagService?.isSaaSCP) {
      this.routeParamSubscriber = this.activatedRoute.queryParams.subscribe(
        (params) => {
          if (!params?.['onboarding-flow'] && this.router.url === '/home') {
            this.getOnboardingFlowStatus();
          }
        },
      );
    }
    this.getAllVCSAccounts();
  }

  getOnboardingFlowStatus() {
    this.uiSettingsControllerService
      .getSettingValueUsingGET({
        entityType: 'CONTROL_PLANE',
        entityId: 'global',
      })
      .subscribe(
        (response: any) => {
          if (
            response?.['DISPLAY_ONBOARDING'] ||
            !response?.hasOwnProperty('DISPLAY_ONBOARDING')
          ) {
            this.triggerPFTour();
          }
        },
        () => {},
      );
  }

  getAllVCSAccounts() {
    this.accountControllerService
      .getAccountsByTypeUsingGET('VERSION_CONTROL')
      .subscribe((response) => {
        this.vcsAccounts = response;
        this.cacheDataService.setVcsAccountDetails(response);
        if (response.length > 0) {
          this.onSaveVcsIntegration(null);
          triggerAnalyticsEvent('ONBOARDING_FLOW_VCS_ACCOUNTS_FOUND');
        } else {
          triggerAnalyticsEvent('ONBOARDING_FLOW_VCS_ACCOUNT_NOT_FOUND');
        }
      });
  }

  initializeOnboarding() {
    triggerAnalyticsEvent('ONBOARDING_FLOW_START');
    this.dialogService.open(this.onboardingStepper, {
      closeOnBackdropClick: false,
      hasBackdrop: true,
      closeOnEsc: false,
    });
  }

  onSaveVcsIntegration(vcsAccountDetails) {
    if (vcsAccountDetails) {
      triggerAnalyticsEvent('ONBOARDING_FLOW_VCS_ACCOUNT_ADDITION_SUCCESS');
    }
    triggerAnalyticsEvent('ONBOARDING_FLOW_STARTER_PROJECT_ADDITION');
    this.disableStep2 = false;
    this.errorCreatingStarterProject = '';
    this.uiStackControllerService.createStarterProjectUsingPOST().subscribe(
      (response) => {
        triggerAnalyticsEvent(
          'ONBOARDING_FLOW_STARTER_PROJECT_ADDITION_SUCCESS',
        );
        this.onProjectCreateSuccess(response);
      },
      (error) => {
        triggerAnalyticsEvent(
          'ONBOARDING_FLOW_STARTER_PROJECT_ADDITION_FAILED',
        );
        this.errorCreatingStarterProject =
          error?.error?.message || error?.message;
        console.log('errorCreatingStarterProject', error);
        this.creatingProject = false;
      },
    );
  }

  onProjectCreateSuccess(stack) {
    this.contextUpdatesService.setLastOpenedBranchInLocalStorage(
      stack?.name,
      stack?.branch,
    );
    this.contextUpdatesService.requestContextSwitcherRefresh();
    this.contextUpdates$ =
      this.contextUpdatesService.contextSwitcherUpdated.subscribe((signal) => {
        if (signal.updated) {
          this.contextUpdates$.unsubscribe();
          this.creatingProject = false;
        }
      });
  }

  triggerPFTour() {
    triggerAnalyticsEvent('TRIGGER_PRODUCT_FRUIT_GUIDE');
    this.router.navigate(['home'], {
      queryParams: {
        ['onboarding-flow']: true,
      },
    });
    setTimeout(() => {
      window.location?.reload();
    }, 600);
  }

  openInviteUser() {
    this.dialogService.open(this.inviteUserTemplateRef);
  }

  ngOnDestroy(): void {
    this.routeParamSubscriber?.unsubscribe();
  }
}
